import { Flex, Text } from '@chakra-ui/react';

import useIsMobile from '../../../hooks/useIsMobile';
import { COMMON_PADDING } from '../../../utils/styleUtil';
import CollapsibleText from '../../generic/CollapsibleText';
import YoplanningHtml from '../../generic/YoplanningHtml';
import ProductProviderTag from '../product/tags/ProductProviderTag';

const ShopResourceDetail = ({ shopResource }) => {
  const isMobile = useIsMobile();

  return (
    <Flex flexDirection="column">
      <Text pt={COMMON_PADDING} fontSize="xl" pb={shopResource.team ? undefined : '.5rem'}>
        {shopResource.label}
      </Text>
      {shopResource.team && <ProductProviderTag providerName={shopResource.team.name} mb="15px" />}

      {shopResource.description && (
        <CollapsibleText startingHeight={55} mb=".5rem" isShown={!isMobile}>
          <YoplanningHtml description={shopResource.description} />
        </CollapsibleText>
      )}
    </Flex>
  );
};

export default ShopResourceDetail;
